import { GridColDef, GridValidRowModel } from "@mui/x-data-grid";
import { ComponentProps } from "react";

import { GqlFilterOption } from "~/__generated__";
import GaiaFilterHeader from "~/modules/app/components/GaiaFilterHeader";
import GaiaDataGrid, { GaiaTableProps } from "~/modules/app/components/GaiaTable";
import ErrorScreen from "~/modules/app/screens/ErrorScreen";

type ExtraGridProps = Partial<Omit<ComponentProps<typeof GaiaDataGrid>, "rows" | "columns" | "loading" | "rowCount">>;
const defaultFilterTransform = (options: GqlFilterOption[]) => options ?? [];

export interface GaiaDataListProps<RowT extends GridValidRowModel> {
    data?: RowT[];
    loading: boolean;
    error?: Error | null;

    /**@deprecated to be removed when we finish refactoring all the pages using filters  */
    filterOptions?: GqlFilterOption[];

    totalRows?: number;
    columns: GridColDef<RowT>[];

    /**@deprecated to be removed when we finish refactoring all the pages using filters  */
    filterModel?: Record<string, string>;

    /**@deprecated to be removed when we finish refactoring all the pages using filters  */
    onFilterModelChange?: (key: string, value: string | null) => void;

    gridModels?: ExtraGridProps;
    filterTransform?: (options: GqlFilterOption[]) => GqlFilterOption[];
    onRowClick?: GaiaTableProps["onRowClick"];
}

export default function GaiaDataList<RowT extends GridValidRowModel>({
    data,
    loading,
    error,
    filterOptions,
    totalRows,
    columns,
    filterModel,
    onFilterModelChange,
    gridModels,
    filterTransform = defaultFilterTransform,
    onRowClick,
}: GaiaDataListProps<RowT>) {
    if (!loading && error) return <ErrorScreen error={error} />;

    return (
        <>
            {filterOptions && onFilterModelChange && (
                <GaiaFilterHeader
                    filterOptions={filterTransform(filterOptions)}
                    filterModel={filterModel}
                    onFilterModelChange={onFilterModelChange}
                />
            )}

            <GaiaDataGrid
                rows={data}
                columns={columns}
                loading={loading}
                rowCount={totalRows}
                {...gridModels}
                onRowClick={onRowClick}
            />
        </>
    );
}
